import React from "react";
import TitledGroup from "../../components/ui/TitledGroup";
import { Card } from "@mui/material";

const TitledLoanSection = ({
  title,
  icon,
  children,
  sx,
  cardSx,
  headerEndContent,
  variant = "h1",
  bodyTopPadding = 4,
}) => {
  return (
    <Card
      sx={{
        p: 2.5,
        pt: 3,
        // pt: 0.6,
        // pb: 3,
        mt: 0,
        // borderRadius: 1,
        // borderRadius: "8px",
        // borderRadius: "14px",
        //
        ...cardSx,
      }}
    >
      <TitledGroup
        collapsable
        icon={icon}
        headerEndContent={headerEndContent}
        variant={variant}
        title={title}
        sx={sx}
        spl
        spr
        suppressHeaderPadding
        bodySx={{ pt: bodyTopPadding }}
      >
        {children}
      </TitledGroup>
    </Card>
  );
};

export default TitledLoanSection;
